import React from 'react';
import { MenuItem, FormControl, InputLabel } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Theme, useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    formControl: {
        minWidth: '200px',
        width: '100%'
    }
}));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const menuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};

function getStyles(name: string, personName: string[], theme: Theme) {
    return {
        fontWeight: personName.includes(name)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular
    };
}
// const multiFilterValue: string[] = [];
export const MultiFilter = ({
    options,
    label,
    value,
    onChange,
    fullWidth
}: {
    options: Array<{ id: string; name: string }>;
    value: string[];
    onChange: (val: string[]) => void;
    label?: string;
    fullWidth?: boolean;
}) => {
    const classes = useStyles();
    const theme = useTheme();

    const [multiFilterValue, setMultiFilterValue] = React.useState<string[]>(value);

    const handleChange = (event: SelectChangeEvent<typeof multiFilterValue>) => {
        const {
            target: { value }
        } = event;
        const val = typeof value === 'string' ? value.split(',') : value;
        // if the last value is 'all', remove all others except 'all'
        if (val.length > 1 && val[val.length - 1] === 'all') {
            // If 'all' is selected, set the value to only 'all'
            setMultiFilterValue(['all']);
            return;
        }
        // if value is more than 1 and it includes 'all', remove 'all' and set the value
        if (val.length > 1 && val.includes('all')) {
            // Remove 'all' from the value
            const newValue = val.filter((v) => v !== 'all');
            setMultiFilterValue(newValue);
            return;
        }
        if (val.length === 0 && options.find((o) => o.id === 'all')) {
            // If no value is selected, set to empty array
            setMultiFilterValue(['all']);
            return;
        }
        setMultiFilterValue(val);
    };

    // Call onChange only after menu closes
    const handleClose = () => {
        // if (multiFilterValue !== value) {
        //     onChange(multiFilterValue);
        // }
        onChange(multiFilterValue);
    };

    React.useEffect(() => {
        // Keep local state in sync if parent changes value
        setMultiFilterValue(value);
    }, [value]);

    return (
        <FormControl fullWidth={fullWidth} variant="outlined" className={classes.formControl}>
            <InputLabel id="multiple-filter-label">{label}</InputLabel>
            <Select
                labelId="multiple-filter-label"
                id="multiple-filter"
                multiple
                value={multiFilterValue}
                onChange={handleChange}
                onClose={handleClose}
                input={<OutlinedInput label={label ?? 'Label'} />}
                MenuProps={menuProps}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.id}
                        value={option.id}
                        style={getStyles(option.name, multiFilterValue, theme)}
                    >
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
interface FilterProps {
    options: { id: string; name: string }[];
    label?: string;
    value: string;
    onChange: (val: string) => void;
    fullWidth?: boolean;
    isMulti?: boolean;
}
const Filter = ({ options, onChange, value, label, fullWidth }: FilterProps) => {
    const classes = useStyles();
    return (
        <FormControl fullWidth={fullWidth} variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">{label || 'Status'}</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                value={value}
                onChange={(evt) => onChange(evt.target.value)}
                id="demo-simple-select-outlined"
                label={label || 'Status'}
                className={classes.formControl}
            >
                {options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default Filter;
